import {mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums";
import Image from "../components/common/Image";
import React from "react";

export const getFormData = (data) => {
    const initialData = {
        fName: "",
        lName: "",
        phone: "",
        email: "",
        password: "",
        role: "",
        status: "",
        customer: {
            gender: "",
            aadhaar: "",
            pan: "",
            documentUpload: [],
        },
    };
    return mergeProperties(initialData, data);
};

export const getTableColumns = ({ActionDropdown, deleteHandler}) => {
    let tableColumns = [
        {
            header: "Name",
            field: "fName",
            render: (item) => {
                return <>{item.fName}{item?.lName ? ` ${item.lName}` : ''}</>;
            },
        },
        {header: "Phone", field: "phone"},
        {header: "Email", field: "email"},
        {header: "Role", field: "role"},
        {header: "Aadhaar", field: "aadhaar"},
        {header: "Pan", field: "pan"},
        {header: "Status", field: "status"},
    ];

    tableColumns.push({
        header: "Action",
        disableSorting: true,
        field: "action",
        align: "right",
        render: (row) => <ActionDropdown row={row} onDelete={deleteHandler} assignEmployee={true}/>,
    });

    return tableColumns;
};

export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map((item) => ({
        id: item.id,
        fName: item.fName,
        lName: item.lName,
        phone: item.phone,
        email: item.email,
        role: item.role,
        aadhaar: item?.customer?.aadhaar,
        pan: item?.customer.pan,
        status: reverseEnum(Status)[item.status],
    }));
};

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            Id: item.id,
            FirstName: item?.fName,
            LastName: item?.lName,
            Phone: item?.phone,
            Email: item?.email,
            role: item.role,
            Aadhaar: item?.customer?.aadhaar,
            Pan: item?.customer.pan,
            Gender: item?.customer.gender,
            Status: reverseEnum(Status)[item.status],
            documentUpload: <div className="d-flex flex-wrap">
                {item?.customer?.documentUpload?.length > 0 &&
                    item.customer.documentUpload.map((docUrl, index) => (
                        <Image
                            key={index}
                            className="border rounded-2 me-2 mb-2"
                            src={docUrl}
                            alt={`Document ${index + 1}`}
                            style={{width: '120px', height: 'auto'}}
                        />
                    ))}
            </div>
        },
    };
};

// Assign Employee to Internal
export const getEmployeeAssignFormData = (data) => {
    const initialData = {
        role: '',
        branch: '',
    };
    return mergeProperties(initialData, data);
};
